import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AiOutlineMail } from "react-icons/ai";
import { BsChevronRight, BsTelephoneFill } from "react-icons/bs";
import { ImLocation } from "react-icons/im";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Container className=" p-0 " fluid>
      <Row className="p-5 bg-light-gray text-white m-0">
        <Col md="4">
          <h4>About Us</h4>
          <div
            className="bg-warning mb-3"
            style={{ width: "50%", height: "2px" }}
          ></div>
          <p>
            GAYATRI INTER COLLEGE DAULTAPUR was established in 1998 and it is
            managed by the Pvt Unaided. It is situated in daulatpur that is the
            area of Masodha block of faizabad in Uttar Pradesh. Area pincode is
            224127. The school consists of Grades from 9 to 12. The school is
            Co-educational and it doesn't have an attached pre-primary section.
            The school is Private in nature and is not using school building as
            a shift-school.
          </p>
        </Col>

        <Col md="4" className="mt-5 mt-md-0">
          <h4>Our Address</h4>
          <div
            className="bg-warning mb-3"
            style={{ width: "50%", height: "2px" }}
          ></div>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14267.410719600148!2d81.9578449!3d26.6211685!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3fabb207c77c8c1c!2sGayatri%20Inter%20College%20Daulatpur!5e0!3m2!1sen!2sin!4v1662276625699!5m2!1sen!2sin"
            style={{ border: 0 }}
            className="w-100"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="address"
          ></iframe>

          <div>
            <span>
              <ImLocation className="text-warning" /> Address: Nauwa Kuwa,
              Daulatpur
            </span>
            <br />
            <span>
              <AiOutlineMail className="text-warning" /> Email:
              anamika387@gmail.com
            </span>{" "}
            <br />
            <span>
              <BsTelephoneFill className="text-warning" /> Mobile: +919451871624
            </span>
          </div>
        </Col>

        <Col md="4" className="mt-5 mt-md-0">
          <div>
            <h4>Quick Links</h4>
            <div
              className="bg-warning mb-3"
              style={{ width: "50%", height: "2px" }}
            ></div>

            <ul type="none" className="p-0">
              <li>
                <Link to="/" className="text-decoration-none text-white">
                  <BsChevronRight className="text-warning" /> About Us
                </Link>
              </li>
              <li>
                <Link to="/" className="text-decoration-none text-white">
                  <BsChevronRight className="text-warning" /> Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-decoration-none text-white">
                  <BsChevronRight className="text-warning" /> Support
                </Link>
              </li>
              <li>
                <Link
                  to="/cookies-policy"
                  className="text-decoration-none text-white"
                >
                  <BsChevronRight className="text-warning" /> Cookies Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-decoration-none text-white"
                >
                  <BsChevronRight className="text-warning" /> Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-services"
                  className="text-decoration-none text-white"
                >
                  <BsChevronRight className="text-warning" /> Terms of services
                </Link>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
      <Row className="m-0 text-center bg-gray text-white py-2 p-md-0">
        <Col md={6} className="mt-2 mt-md-0">
          <span>Gayatri Inter College &copy;1998, All Rights Reserved</span>
        </Col>
        <Col md={6} className="mt-2 mt-md-0">
          <span>
            Developed and Managed By ❤️{" "}
            <Link
              className="text-decoration-none text-white"
              to={{ pathname: "https://www.linkedin.com/in/rahulraifzb" }}
            >
              Rahul Rai
            </Link>
          </span>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
